var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouseWithMagnifier = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H7C4.79086 21 3 19.2091 3 17V11.1C3 9.73298 3.6214 8.44008 4.68886 7.5861L9.18886 3.9861C10.8323 2.6713 13.1677 2.6713 14.8111 3.9861L19.3111 7.5861C20.3786 8.44008 21 9.73298 21 11.1V12",
    stroke: "#5361F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.452 14.952C14.5225 15.8815 14.2445 17.2793 14.7475 18.4937C15.2505 19.7081 16.4355 20.5 17.75 20.5C19.0645 20.5 20.2495 19.7081 20.7525 18.4937C21.2556 17.2793 20.9775 15.8815 20.0481 14.952C19.4386 14.3425 18.612 14 17.75 14C16.8881 14 16.0614 14.3425 15.452 14.952",
    stroke: "#5361F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0669 21L15.4854 19.5815L14.0669 21Z",
    stroke: "#5361F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouseWithMagnifier, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HouseWithMagnifier.e6e98a71.svg";
export { ForwardRef as ReactComponent };